/**
 * Module quản lý lưu trữ bền vững (Persistence Layer) cho Workspace
 * Hỗ trợ lưu trữ trên LocalStorage an toàn, tự động bọc JSON, chống lỗi crash khi dữ liệu hỏng
 */

const STORAGE_PREFIX = 'workspace_';

export class WorkspaceStorage {
  /**
   * Lưu dữ liệu vào storage theo khóa
   * @param {string} key Khóa lưu trữ
   * @param {any} value Giá trị cần lưu (Object, Array, chuỗi, số)
   * @returns {boolean} true nếu lưu thành công, false nếu thất bại
   */
  static set(key, value) {
    if (!key || typeof key !== 'string') return false;

    try {
      const fullKey = STORAGE_PREFIX + key.trim();
      const payload = {
        version: 1,
        updatedAt: Date.now(),
        data: value
      };
      localStorage.setItem(fullKey, JSON.stringify(payload));
      return true;
    } catch (err) {
      console.warn(`[WorkspaceStorage] Lỗi khi ghi khóa "${key}":`, err.message);
      return false;
    }
  }

  /**
   * Đọc dữ liệu từ storage theo khóa
   * @param {string} key Khóa lưu trữ
   * @param {any} [defaultValue=null] Giá trị mặc định nếu không tìm thấy hoặc lỗi
   * @returns {any} Dữ liệu đã giải mã hoặc giá trị mặc định
   */
  static get(key, defaultValue = null) {
    if (!key || typeof key !== 'string') return defaultValue;

    try {
      const fullKey = STORAGE_PREFIX + key.trim();
      const raw = localStorage.getItem(fullKey);
      if (!raw) return defaultValue;

      const parsed = JSON.parse(raw);
      // Kiểm tra cấu trúc bản ghi lưu trữ
      if (parsed && typeof parsed === 'object' && 'data' in parsed) {
        return parsed.data;
      }
      return parsed;
    } catch (err) {
      console.warn(`[WorkspaceStorage] Lỗi khi đọc khóa "${key}":`, err.message);
      return defaultValue;
    }
  }

  /**
   * Xóa một khóa khỏi storage
   * @param {string} key Khóa cần xóa
   * @returns {boolean}
   */
  static remove(key) {
    if (!key || typeof key !== 'string') return false;

    try {
      const fullKey = STORAGE_PREFIX + key.trim();
      localStorage.removeItem(fullKey);
      return true;
    } catch (err) {
      console.warn(`[WorkspaceStorage] Lỗi khi xóa khóa "${key}":`, err.message);
      return false;
    }
  }
}
